import { useContext } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MarkerModalContext } from "../context/MarkerModal";
import { markers } from "../markers";

const transition = {
  duration: 0.5,
};

const variants = {
  show: {
    opacity: 1,
    transition,
  },
  hide: {
    opacity: 0,
    transition,
  },
};

const MarkerModal = () => {
  const { showModal, setShowModal, activeMarker } = useContext(
    MarkerModalContext
  );
  const marker = markers[activeMarker];

  if (!marker) return null;

  const imageUrl = require(`../assets/images/items/${marker.image}`).default;

  return (
    <>
      <AnimatePresence>
        {showModal && (
          <motion.div
            variants={variants}
            initial="hide"
            animate="show"
            exit="hide"
            className="modal-marker"
            onClick={() => setShowModal(false)}
          >
            <div className="modal-marker__content">
              <h1 className="modal-marker__title">{marker.text}</h1>
              <div className="modal-marker__image-container">
                <img className="modal-marker__image" src={imageUrl} alt="" />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default MarkerModal;
